
import UpdateShipping from "components/Profiles/SettingShipping/UpdateShipping";
import NotFooterLayout from "layouts/NotFooterLayout";
import { useParams } from "react-router-dom";


function UpdateShippingPage() {
  const { geography_id, transport_type, province_id, district_id, is_free } = useParams<{ geography_id: string, transport_type: string, province_id: string | undefined, district_id: string | undefined, is_free: string | undefined }>();

  console.log(geography_id, transport_type);
  return (
    <NotFooterLayout namePage="แก้ไขค่าจัดส่ง" >
      <div className="layout-content">
        <UpdateShipping geography_id={geography_id ?? ''} transport_type={transport_type ?? ""}
          province_id={province_id} district_id={district_id}
          is_free={is_free === 'true'}
        />
      </div>
    </NotFooterLayout>
  );
}

export default UpdateShippingPage;